import {
  createElement,




} from 'react'
import { cn} from './cn'









/**
 * Helper similar to `styled` but with clsx style tailwind classes.
 *
 * Usage:
 *   const StyledDiv = twStyled('div')('bg-tomato-500 p-4')
 *   const DynamiclyStyledDiv = twStyled('div')(({isHighlighted}: {isHighlighted: boolean}) => [
 *     'bg-sky-500 p-4',
 *     {'bg-tomato-500': isHighlighted},
 *     isHighlighted && 'shadow-lg'
 *   ])
 *   const StyledCustomComponent = twStyled(MyCustomComponent)('bg-tomato-500 p-4')
 *
 * For VSCode autocomplete, add `twStyled` to the "Tailwind CSS: Class Functions" setting.
 */
export const twStyled =
  (element) =>
  (
    fun,
    ...classValues
  ) =>
  (props) => {
    const extraValues = typeof fun === 'function' ? fun(props ) : fun
    const {children, className: classNameOverrides, ...rest} = props
    const mergedClassName = cn(extraValues, ...classValues, classNameOverrides)
    return createElement(element, {...rest, className: mergedClassName}, children)
  }
